<template>
  <div
    id="app"
    :class="[
      $store.state.browser ? $store.state.browser.name:'',
      $store.state.browser ? $store.state.browser.os:''
    ]"
  >
    <MainView />
  </div>
</template>

<script>
import FilterMixin from '@/components/common/filter/FilterMixin.vue';
import MainView from '@/views/MainView.vue';

const { detect } = require('detect-browser');

export default {
  name: 'App',
  components: { MainView },
  mixins: [FilterMixin],
  computed: {
  },
  mounted() {
  },
  created() {
    const browser = detect();
    this.$store.commit('setBrowser', browser);
    this.countFilterValues();
  },
};
</script>

<style lang="stylus">
  #app {
    background-color: $cl-blue;
  }
</style>
